import { CSSObject } from '@chakra-ui/react';

export const RaceMeetingsList: CSSObject = {
  px: '0',
};

export const BoxWrapper: CSSObject = {};
